<template>
    <common-layout>
        <div class="header">
            <i class="el-icon-arrow-left" @click="handleBack"></i>
        </div>
        <div class="item_detail">
            <span>课程学时</span>
            <span>{{(learingDetail.classHours/60/45).toFixed(2)}}</span>
        </div>
        <div class="item_detail">
            <span>已学学时</span>
            <span>{{(learingDetail.timeStudyed/60/45)==0?'0':(learingDetail.timeStudyed/60/45).toFixed(2)}}</span>
        </div>
        <div class="item_detail" style="border-bottom:none;">
            <span>是否完成课程</span>
            <span>{{Number(learingDetail.classHours)>Number(learingDetail.timeStudyed)?'未完成':'已完成'}}</span>
        </div>
        <el-collapse class="outlist" >
            <el-collapse-item title="学时记录" name="2">
                <el-collapse class="inlist" v-model="chapterIdArr" v-if="classHour.length>0" >
                    <el-collapse-item v-for="(item) in classHour" :key="item.chapterId" :title="item.label" :name="item.chapterId">
                        <div class="list">
                            <div class="item" v-for="(childItem,childIndex) in item.children" :key="childItem.chapterId">
                                <div class="left">
                                    第{{childIndex+1}}节：{{childItem.label}}
                                </div>
                                <div class="center">
                                    
                                </div>
                                <div class="right">
                                    <el-progress :percentage="childItem.completion*1" :stroke-width="8" color="#3964E6"></el-progress>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-collapse-item>
        </el-collapse>
        
        <div class="item_detail item_end">
            <span>学时证书</span>
            <span></span>
        </div>
        <div class="zhenshu">
            <div v-if="Number(learingDetail.classHours)>Number(learingDetail.timeStudyed)">
                <img src="~@/assets/images/haihengerr.png" style="margin:0 auto;" alt="">
            </div>
            <div class="img_box" v-else>
                <div class="zhenshu_header">
                    <img src="~@/assets/images/haihenglogo.png" alt="logo">
                    <span>结业证书</span>
                </div>
                <div class="zhengshu_content">
                    <p class="pp1">{{$store.getters.name}}  学员于 {{learingDetail.beginTime|formats}} 至 {{learingDetail.endTime|formats}} 在郑州海恒职业培训学校，培训    {{learingDetail.title}}    课程 成绩合格，准予结业  ！</p>
                    <p class="pp2">特发此证。</p>
                    <p class="pp3">
                        <span>
                            <img src="~@/assets/images/haihengcode.png" alt="">
                            郑州海恒职业培训学校
                        </span>
                    </p>
                </div>
            </div>
            <div style="padding:30px 100px 0;" v-if="!isShow">
                <el-button style="background:#3964E6;border-color:#3964E6;" type="primary" @click="handleStudy">去学习</el-button>
            </div>
        </div>
    </common-layout>
</template>
<script>
import CommonLayout from '@/components/LearningCenterComponents/Common'
import {chapterStudyRecord} from '@/api/coursedetails.js'
import { parseTime } from '@/utils'
export default {
    components:{
        CommonLayout
    },
    props:{
        learingDetail:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        isShow:{
            type:Boolean,
            default:true
        }
    },
    data(){
        return {
            classHour:[],
            chapterIdArr:[]
        }
    },
    filters:{
        formats(date){
            return parseTime(new Date(date.replace(/-/g,'/')),'yyyy年MM月')
        }
    },
    mounted(){
        console.log(this.learingDetail)
        if(this.learingDetail.courseId){
            this.chapterStudyRecord({
                traineeId:this.$store.getters.userId,
                courseId:this.learingDetail.courseId
            })
        }
        
    },
    methods:{
        handleChange(val){
            console.log(val);
        },
        chapterStudyRecord(data){
            chapterStudyRecord(data).then(res=>{
                this.classHour = res.data.chapterTree
                this.chapterIdArr = this.classHour.map(v=>v.chapterId)
            })
        },
        handleBack(){
            this.$emit('setCallBack')
        },
        handleStudy(){
            let rourl =  this.$router.resolve({path:"/coursedetails",query:{id:this.learingDetail.courseId}});
            window.open(rourl.href);
        }
    }
}
</script>
<style lang="scss" scoped>
.header{
    padding: 30px 50px;
    i{
        font-size: 30px;
        font-weight: bold;
        cursor: pointer;
        &:hover{
            color: #3964E6;
        }
    }
}
.item_detail{
    padding: 19px 100px;
    border-bottom: 1px solid #eeeeee;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    &.item_end{
        border-bottom: none;
    }
    &.record{
        cursor: pointer;
    }
}
.outlist{
    ::v-deep {
        .el-collapse-item__header{
            padding: 0 100px;
            font-size: 20px;
        }
        .el-collapse-item__content{
            padding-bottom: 0;
        }
    }
    .inlist{
        ::v-deep {
            .el-collapse-item__header{
                padding: 0 100px 0 120px;
                font-size: 16px;
            }
        }
        .list{
            background: #f8f8f8;
            padding:20px 120px 10px 140px;
        }
        .item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 10px;
            .right{
                width: 200px;
            }
            .center{
                width: 20px;
            }
            .left{
                flex: 1;
                overflow:hidden; //超出的文本隐藏
                text-overflow:ellipsis; //溢出用省略号显示
                white-space:nowrap; //溢出不换行
            }
        }
    }
}

.zhenshu{
    padding-bottom: 48px;
    .img_box{
        width: 490px;
        border: 15px solid #1761AC;
        margin: 0 auto;
        background: url('~@/assets/images/haihengbg.png') no-repeat center center;
        background-size: 100% 100%;
        padding: 34px 58px 47px;
        .zhenshu_header{
            font-size: 38px;
            font-weight: 800;
            color: #0958A7;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            img{
                margin-right: 14px;
            }
        }
        .zhengshu_content{
            .pp1{
                text-indent: 2em;
            }
            .pp2{
                text-indent: 4em;
                margin-bottom: 10px;
            }
            .pp1,.pp2{
                line-height: 1.8;
            }
            .pp3{
                display: flex;
                justify-content: flex-end;
                span{
                    position: relative;
                }
                img{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
            }
        }
    }
}

</style>
